/** Shared routes for global trading navbar (all screens). */
export const TRADING_NAV_ITEMS = [
  { path: '/', label: 'Options', icon: '⚡', key: 'options' },
  { path: '/NormalTrading', label: 'Normal V1', icon: '📈', key: 'normal' },
  { path: '/NormalTrading/Testing', label: 'V1 Testing', icon: '🧪', key: 'v1test' },
  { path: '/NormalTrading/Sold', label: 'Sold Today', icon: '✅', key: 'sold', highlight: true },
  { path: '/ledger/normal', label: 'Ledger', icon: '📒', key: 'ledger' },
  { path: '/NormalTrading/Master', label: 'V1 Master', icon: '⚙', key: 'master' },
  { path: '/NormalTrading/Testing/Master', label: 'V1 Master TEST', icon: '🧰', key: 'mastertest' },
  { path: '/TwoHourTrading', label: '2 Hour', icon: '⏱', key: 'twohour' },
  { path: '/DegenDashboard', label: 'Degen', icon: '🎲', key: 'degen' },
  { path: '/CncDegenDashboard', label: 'CNC Delivery', icon: '📦', key: 'cnc' },
  { path: '/Report', label: 'Report', icon: '📊', key: 'report', aliases: ['/DegenDashboard/Report', '/degen/report'] }
];

export function isNavItemActive(pathname, item) {
  const p = pathname || '/';
  if (p === item.path) return true;
  if (item.aliases?.includes(p)) return true;
  if (item.path === '/NormalTrading/Testing' && p.startsWith('/NormalTrading/Testing')) return true;
  if (item.path === '/NormalTrading/Testing/Master' && p === '/NormalTrading/Testing/Master') return true;
  if (
    item.path === '/NormalTrading'
    && p.startsWith('/NormalTrading')
    && p !== '/NormalTrading/Master'
    && p !== '/NormalTrading/Sold'
    && !p.startsWith('/NormalTrading/Testing')
  ) return true;
  if (item.path === '/ledger/normal' && p.startsWith('/ledger/normal')) return true;
  return false;
}
